import { render, staticRenderFns } from "./body-column.vue?vue&type=template&id=91852294&scoped=true"
import script from "./body-column.vue?vue&type=script&lang=js"
export * from "./body-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91852294",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91852294')) {
      api.createRecord('91852294', component.options)
    } else {
      api.reload('91852294', component.options)
    }
    module.hot.accept("./body-column.vue?vue&type=template&id=91852294&scoped=true", function () {
      api.rerender('91852294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/email-quarantine/columns/body-column.vue"
export default component.exports